import jAccordion from './../libs/j_accordion';
import Ua from './../libs/j_ua';
import jSmoothScroll from './../libs/j_smoothScroll';


const Init =  () => {

    // accordion
    const J_ACCORDION = new jAccordion(
        ".j-accordion",
        {
            toggleSpeed: 400
        }
    );

    // User Agent
    const UA = new Ua();

    if ( UA.isSp ) {

      // if ( UA.isIphone ) {
      //   document.body.classList.add('iphone');
      // } else if ( UA.isAndroid ) {
      //   document.body.classList.add('android_sp');
      // } else {
      //   document.body.classList.add('other_sp');
      // }

      document.getElementById('ToCvBtn').textContent = '今すぐ申し込む';

    } else {

      document.body.classList.add('pc_tab');

    };

    // /////////////////////////////
    // ナビゲーション
    // //////////////////////////////
    let isSmoothScrolling = false;
    let isFixBtn = false;

    const SECTION = [].slice.call ( document.querySelectorAll('.f-section'), 0 );
    const NAVIBUTTON = [].slice.call ( document.querySelectorAll('#nav li a'), 0 );
    const ANCHOR = [].slice.call ( document.querySelectorAll('a[href^="#"],area[href^="#"]'), 0 );
    const FIX_BTN = document.getElementById('fixBtn');

    // smooth scroll
    const J_SCROLL = new jSmoothScroll(
        "a.ss",
        {
            easing: "easeOutQuint",
            ignore: ".ignore",
            posFix: -1,
            blank: true,
        }
    );
    J_SCROLL.CarryingHash = function(hash) {

      isSmoothScrolling = true;

      const TARGET = '#' + hash;

      NAVIBUTTON.forEach( (v,i) => {

        v.classList.remove('current');

        if ( v.hash === TARGET ) {
          v.classList.add('current');
        }

      });

    }
    J_SCROLL.ScrollEnd = function() {

      isSmoothScrolling = false;

    }


    const GetCurrentPosition = () => {

        const SCROLL_TOP = document.documentElement.scrollTop || document.body.scrollTop;
        const WINDOW_HEIGHT = window.innerHeight;
        const SCROLL_BOTTOM = SCROLL_TOP + WINDOW_HEIGHT;

        const EACH_HEIGHTS = SECTION.map( (v) => {
          return v.getBoundingClientRect().top + window.pageYOffset;
        });

        EACH_HEIGHTS.forEach( (v,i,a) => {

          if ( SCROLL_TOP >= a[i] && !isSmoothScrolling ) {

            NAVIBUTTON.forEach( (w) => {
              w.classList.remove('current');
            });
            NAVIBUTTON[i].classList.add('current');

          }

        });

        if ( SCROLL_BOTTOM >= EACH_HEIGHTS[2] && SCROLL_BOTTOM <= EACH_HEIGHTS[7] ) {
          if ( !isFixBtn ) {
            isFixBtn = true;
          }
        } else {
          if ( isFixBtn ) {
            isFixBtn = false;
          }
        }

        if ( !isFixBtn ) {
          FIX_BTN.classList.remove('active');
        } else {
          FIX_BTN.classList.add('active');
        }

    };

    window.addEventListener('load', ()=> {
      GetCurrentPosition();
    });
    window.addEventListener('resize', ()=> {
      GetCurrentPosition();
    });
    window.addEventListener('scroll', ()=> {
      GetCurrentPosition();
    });

}

export default Init;
